import { useEffect, useState } from 'react';

// Portaled camera stays inside the visible iPhone viewport, even after input zoom/keyboard.
export const useCameraViewport = open => {
  const read = () => {
    const view = window.visualViewport;
    return { left: view?.offsetLeft || 0, top: view?.offsetTop || 0,
      width: view?.width || window.innerWidth, height: view?.height || window.innerHeight };
  };
  const [viewport, setViewport] = useState(read);
  useEffect(() => {
    if (!open) return;
    const update = () => setViewport(read());
    update();
    window.visualViewport?.addEventListener('resize', update);
    window.visualViewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      window.visualViewport?.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [open]);
  return viewport;
};